module.exports = __webpack_public_path__ + "static/media/eight.f3e56cc4.svg";